import React from 'react';
interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  intro?: string;
  align?: 'left' | 'center';
}
export function PageHeader({
  eyebrow,
  title,
  intro,
  align = 'left'
}: PageHeaderProps) {
  const centered = align === 'center';
  return <div className={`max-w-editorial mx-auto px-6 pt-16 pb-10 md:pt-24 md:pb-14 ${centered ? 'text-center' : ''}`} data-id="element-139">
      {eyebrow && <p className={`eyebrow text-trust-600 mb-5 ${centered ? 'mx-auto' : ''}`} data-id="element-140">
          {eyebrow}
        </p>}
      <h1 className={`font-serif tracking-tightest text-ink text-4xl md:text-6xl leading-[1.02] ${centered ? 'mx-auto max-w-3xl' : 'max-w-4xl'}`} style={{
      fontWeight: 500
    }} data-id="element-141">
        {title}
      </h1>
      {intro && <p className={`mt-6 text-lg md:text-xl text-stone-600 leading-relaxed ${centered ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`} data-id="element-142">
          {intro}
        </p>}
    </div>;
}